import {
  convertPromotionApiResponseToRewards,
  filterMyArchive,
} from './transformations/transformations'
import axios from '../utilities/axios'

const loadMyRewards = async () =>
  axios
    .get('/api/v1/redemption/')
    .then(({ myRewards }) => myRewards.map(convertPromotionApiResponseToRewards))

async function logRevealKey(payload) {
  return axios.post('/api/v1/redemption/log', payload)
}

const loadMyArchive = async () =>
  axios
    .get('/api/v1/redemption/archive')
    .then(({ myArchive }) => myArchive.redemptionContentArchive.map(filterMyArchive))

export default {
  loadMyArchive,
  loadMyRewards,
  logRevealKey,
}
